import {CostDistributionType} from "./CostDistributionType";
import {CostDistributionConfig} from "./CostDistributionConfig";

export class EnterpriseCostDistributionConfig extends CostDistributionConfig{
  enterpriseId:               number;
  costDistributionType =      CostDistributionType.SEGMENT1;


}
